import React from 'react';
import { ToastContainer } from 'react-toastify';
import { ThemeProvider } from 'react-bootstrap';
import Main from './main';
import './css/App.css';
import 'react-toastify/dist/ReactToastify.css';
const App = () => {
    return <>
        <ThemeProvider dir="rtl">
            <ToastContainer position="top-center"
                autoClose={3000}
                hideProgressBar
                newestOnTop={false}
                closeOnClick
                rtl={true}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                toastStyle={{ fontFamily: "IRANSans" }}
               />
            <Main />
        </ThemeProvider>
    </>
};

export default App;

